// GLOBAL STARTER DEPENDENCIES
import $ from "jquery";
import "../node_modules/bootstrap/dist/js/bootstrap.js";
import "../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.js";
import "../node_modules/timepicker/jquery.timepicker.js";
import "../node_modules/holderjs/holder.js";

var Flickity = require('flickity');
require('flickity-imagesloaded');
require('flickity-fade');

Flickity.setJQuery($);

require("es6-promise").polyfill();

import * as Moment from "expose-loader?Moment!moment";
import "expose-loader?Vue!vue";
export { photoswipe } from "./photoswipe";
export { photoswipeUi } from "./photoswipe-ui-default";
export { slideshow } from "./slideshow";
export { draggabilly } from "./draggabilly";
export { scrollmagic } from "./scroll-magic";
export { modernizr } from "./modernizr-custom";

setTimeout(function() {
  $("body").removeClass("preload");
}, 500);

// load the galleries AFTER the page loads. Very important.
$(window).on('load', function() {
  const galleries = document.querySelectorAll('.gallery');
  for (let i = 0, len = galleries.length-1; i <= len; i++) {
    if ($('.'+ galleries[i].className).length) {
      const gallery = new Flickity(document.getElementById(galleries[i].parentNode.id), {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        hash: true,
        groupCells: true,
        cellSelector: ".gallery-cell",
        initialIndex: 0,
        resize:false,
        percentPosition: false,
        imagesLoaded: true,
        on: {
          change: function (idx) {
            console.log('Slide changed to ' + idx);
          }
        },
        arrowShape:
          "M22.6633412,50 L81.25,50 C82.1129449,50 82.8125,49.3004449 82.8125,48.4375 C82.8125,47.5745551 82.1129449,46.875 81.25,46.875 L22.6633412,46.875 L51.076171,19.8828116 C51.7018056,19.2884588 51.7271645,18.2994635 51.1328116,17.673829 C50.5384588,17.0481944 49.5494635,17.0228355 48.923829,17.6171884 L17.673829,47.3046884 C17.0253903,47.9207051 17.0253903,48.9542949 17.673829,49.5703116 L48.923829,79.2578116 C49.5494635,79.8521645 50.5384588,79.8268056 51.1328116,79.201171 C51.7271645,78.5755365 51.7018056,77.5865412 51.076171,76.9921884 L22.6633412,50 Z"
      });
    }
  }
let headerSlideshow;
if($('.header-slideshow').length) {
	headerSlideshow = new Flickity('.header-slideshow', {
		cellAlign: "center",
		contain: true,
		pageDots: false,
		cellSelector: ".gallery-cell",
		imagesLoaded: true,
		prevNextButtons: false,
		autoPlay: 5000,
		pauseAutoPlayOnHover: false,
		fade: true
	});
}
});

// ****************************************************************************
// GLOBAL JAVASCRIPT (COMPILES INTO SCRIPTS-BUNDLE.JS AND SERVED ON EVERY PAGE)
// ****************************************************************************

function checkScrollDown() {
	if($('#search-app').hasClass('nav-dark') && $('.page-wrapper').hasClass('scroll-down')) {
  	$(".page-wrapper").removeClass("scroll-down");
		// console.log('removing scroll-down');
	}
}

$("body:not(.weddings-private-events) #header").on("mouseenter", function(e) {
  e.preventDefault();
	if(!$('#search-app').hasClass('nav-dark')) {
  	$(".page-wrapper").addClass("scroll-down");
	}
});

$("#header").on("mouseleave", function(e) {
  e.preventDefault();
	checkScrollDown();
});

$(".navbar-toggler").on("click", function(e) {
  e.preventDefault();
  $("body").toggleClass("menu-open");
});

let donateEl = $('#nav-utility').find('.nav-item.donate a');
if(donateEl.length) {
  let donateBtn = donateEl.first().clone();
  donateBtn.attr('id', 'donate-btn');
  $('#hamburger.navbar-toggler').after(donateBtn);
}

$("#click-zone").on("click", function(e) {
  e.preventDefault();
  $("#newsletter").toggleClass("open");
});

$(document).on('click', '#subnav a', function() {
	checkScrollDown();

	if (
		location.pathname.replace(/^\//, "") ==
		this.pathname.replace(/^\//, "") &&
		location.hostname == this.hostname
		) {
			let target = $(this.hash);
			target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
			if (target.length) {
				let offset = 15 + $('#subnav').outerHeight();
				let scrollTop = target.offset().top - offset;

				$("html, body").animate(
					{ scrollTop: scrollTop },
					800
				);
				return false;
		}
	}
});

if (localStorage.getItem("stickersDismissed") != "true") {
  // console.log("no stickersDismissed");
  $("#sticker-wrapper").removeClass("closed");
}

$(".sticker-dismiss").on("click", function(e) {
  e.preventDefault();
  $("#sticker-wrapper").addClass("closed");
  $("#sticker-toggle").toggleClass("active");

  if ($("html").hasClass("touchevents")) {
    localStorage.setItem("stickersDismissed", "true");
  }
});

$("#sticker-toggle").on("click", function(e) {
  e.preventDefault();
  $("#sticker-wrapper").toggleClass("closed");
  $(this).toggleClass("active");
});

let hsPlaying = true;
$('.header-slider-control a').on("click", (e) => {
  e.preventDefault();
  let controls = $('.header-slider-control');
  if(hsPlaying) {
		hsPlaying = false;
    headerSlideshow.pausePlayer();
    controls.removeClass('playing').addClass('paused');
  } else {
		hsPlaying = true;
    headerSlideshow.unpausePlayer();
    controls.removeClass('paused').addClass('playing');
  }
	console.log(hsPlaying);
});

$(document).on('scroll', function() {
	checkScrollDown();
});



// WEBPACK FOOTER //
// ./scripts/global.js